<template>
  <div class="container guess_like" v-if="guessLike.length">
    <h3 class="guess_title page_text_font">
      <span >{{recommended_product.title}}</span>
      <em @click="change_like">{{$t('recommend.no_like_this')}}</em>
    </h3>
    <div class="guess_list_wrap">
      <span class="iconfont" @click="prev" v-show="!this.slides==0">&#xe603;</span>
      <span class="iconfont" @click="next" v-show="this.slides < this.click_num">&#xe602;</span>
      <ul @touchstart="startMove" @touchend="endMove" class="guess_list_box clearfix">
        <li class="guess_list_item" v-for="(item,index) in guessLike" :key="item.ID">
          <div class="item_gallery">
            <a :href="item.path||item.public_url">
              <img
                v-if="variants[index].feature_image"
                :data-srcset="variants[index].feature_image.srcset"
                :srcset="variants[index].feature_image.srcset"
                data-sizes="auto"
                @error.once="imageFailure"
                class="lazyload"
                alt
              />
              <img
                v-else
                :bb="index"
                :aa="guessLike[index].feature_image"
                :data-srcset="guessLike[index].feature_image?guessLike[index].feature_image.srcset:defaultImage"
                data-sizes="auto"
                @error.once="imageFailure"
                class="lazyload"
                alt
              />
              <span
                class="sale_tag saveprice_tag"
                v-if="recommended_product.tag!='0'&&variants[index].price-0<variants[index].regular_price-0"
              >-{{100- Math.round((variants[index].price-0)/(variants[index].regular_price-0)*100) }}%</span>
            </a>
          </div>
          <div class="item_name secondary_title" v-if="recommended_product.displayProductName!='0'">
            <a
              :href="item.path||item.public_url"
              :title="item.post_title"
              :class="recommended_product.displayProductName=='2'?'oneline':''"
            >{{item.post_title}}</a>
          </div>
          <div
            v-if="recommended_product.addCartButton!='0'"
            class="item_attribute"
            :class="item.variants&&item.variants.length>1?'has_select':''"
          >
            <select
              v-if="item.variants&&item.variants.length>1"
              name
              id
              v-model="addproduct[index].variant_id"
              @change="selectvariants(item,index)"
            >
              <option v-for="subitem in item.variants" :key="subitem.ID" :value="subitem.ID">
                <span
                  v-for="(option,optionindex) in subitem.attrs"
                  :key="subitem.ID+optionindex+option.value"
                >{{optionindex==subitem.attrs.length-1?option.value:option.value+"·"}}</span>
              </option>
            </select>
          </div>
          <p class="item_price">
            <!-- <span
              class="regular_price"
              v-if="variants[index].price-0<variants[index].regular_price-0"
            >${{variants[index].regular_price}}</span>-->
            <!-- <v-selectprice :price="variants[index].price"></v-selectprice> -->
            <!-- <v-selectprice :price='variants[index].price'></v-selectprice> -->

            <v-selectprice
              :price="variants[index].price"
              :font-size="14"
              :regular-font-size="14"
              :regular_price_num="variants[index].price-0<variants[index].regular_price-0?variants[index].regular_price:0"
              :disable_select="true"
              :country="!show_currency_selector?'':$store.state.pricetype"
            ></v-selectprice>
          </p>
          <!-- <div class="item_star" v-if="item.average_rating">
            <v-comments-star :disabled="true" :average_rating="item.average_rating" font_size="18"></v-comments-star>
          </div>-->
          <div v-if="recommended_product.addCartButton!='0'">
            <button
              class="item_button minor_button "
              v-if="item.buy_able"
              @click="addcart(index)"
            ><span class="secondary_title"> {{$t('recommend.add_to_cart')}}</span></button>
            <button v-else class="item_button minor_button " id="slodout"><span class="secondary_title">{{$t('detail.sold_out')}}</span> </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
import defaultImage from "../../../../../public/images/no-image.gif";
import vCommentsStar from "../comments/commentsstar";
import API from "../../../API";
export default {
  props: [
    "recommended_product",
    "pixel",
    "ga",
    "cart_type",
    "product_id",
    "show_currency_selector",
    "theme"
  ],
  data() {
    return {
      guessLike: [],
      addproduct: [],
      variants: [],
      defaultImage,
      slides: 0,
      getSymbolFromCurrency: "",
      guess_list_box: 0, //ul盒子宽度
      guess_list_item: 0, //li宽度
      box_left: 0, //当前left值
      base_num: 0, //每次展示个数
      click_num: 0, //列表数量/每次展示个数-1等于可点击次数
      offset_num: 0, //超过可点击次数后展示偏移展示位置
      startX: 0,
      endX: 0
    };
  },
  methods: {
    prev() {
      this.slides--;
      this.complete_num();
      if (this.slides <= 0) {
        this.$(".guess_list_box").animate(
          {
            left: "0px"
          },
          300
        );
        this.slides = 0;
      } else {
        this.$(".guess_list_box").animate(
          {
            left: `${this.box_left + this.guess_list_box}px`
          },
          300
        );
      }
    },
    complete_num() {
      this.guess_list_box = this.$(".guess_list_box").width();
      this.guess_list_item = this.$(".guess_list_item").innerWidth();
      this.box_left = this.$(".guess_list_box").position().left;
      this.base_num = this.guess_list_box / this.guess_list_item; //每次展示个数
      this.click_num = Math.ceil(this.guessLike.length / this.base_num) - 1; //列表数量/每次展示个数-1等于可点击次数
      this.offset_num = this.guessLike.length % this.base_num; //超过可点击次数后展示偏移展示位置
    },
    next() {
      this.slides++;
      this.complete_num();
      if (this.slides <= this.click_num) {
        this.$(".guess_list_box").animate(
          {
            left: `${this.box_left - this.guess_list_box}px`
          },
          300
        );
      } else {
        this.$(".guess_list_box").animate(
          {
            left: `${this.box_left -
              this.guess_list_box +
              this.offset_num * this.guess_list_item}px`
          },
          300
        );
      }
    },
    async change_like() {
      const _this = this;
      const CancelToken = this.$axios.CancelToken;
      this.cancelTokenFn && this.cancelTokenFn();
      this.cancelTokenFn = null;
      try {
        let res = await this.$axios.get(
          "/api/store/recommended-products/" + this.product_id,
          {
            cancelToken: new CancelToken(function executor(c) {
              _this.cancelTokenFn = c;
            })
          }
        );
        this.guessLike = res.data;
        this.variants = [];
        this.addproduct = [];
        console.log("guessLike", this.guessLike);
        this.guessLike.forEach(item => {
          if (item.variants && item.variants.length) {
            this.variants.push(item.variants[0]);
            this.addproduct.push({
              quantity: "1",
              product_id: item.ID,
              variant_id: item.variants[0].ID
            });
          } else {
            this.addproduct.push({
              quantity: "1",
              product_id: item.ID
            });
            this.variants.push(item);
          }
        });
        if (this.guessLike.length) {
          this.$nextTick(this.complete_num);
        }
        console.log("addproduct", this.addproduct);
        console.log("variants", this.variants);
      } catch (error) {
        console.log(error.response);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    async addcart(index) {
      try {
        let res = await this.$axios.post(API.addcart, this.addproduct[index]);
        if (window.fbq) {
          let content_category = [];
          if (
            this.guessLike[index].categories &&
            this.guessLike[index].categories.length
          ) {
            this.guessLike[index].categories.forEach(item => {
              content_category.push(item.name);
            });
          }
          window.fbq("track", "AddToCart", {
            content_type: "product_group",
            content_ids: [this.addproduct[index].product_id],
            value: this.variants[index].price,
            num_items: this.addproduct[index].quantity,
            content_name: this.variants[index].title,
            currency: res.data.currency ? res.data.currency : "USD",
            content_category
          });
        }
        if (window.gtag) {
          window.gtag("event", "add_to_cart");
        }
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.$store.dispatch("change_news_cart", res.data);
        if ((this.theme == "Brooklyn" || this.theme=='showtime') && this.cart_type == "drawer") {
          if(this.theme == "Brooklyn"){
          this.$store.dispatch("change_cart_type", true);
          }
          if(this.theme=='showtime'){
            document.body.scrollTop=document.documentElement.scrollTop=0
            this.$("#collapseExample").collapse('show');  
          }
        } else if ((this.theme == "venue"||this.theme=='showtime') && this.cart_type == "popup") {
          this.$("#modalCart").modal("show");
        } else {
          window.open("/cart", "_self");
        }
      } catch (error) {
        this.loading = false;
        if (error.response.status == 422) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    },
    selectvariants(item, index) {
      if (this.guessLike[index].variants) {
        this.guessLike[index].variants.some(item => {
          if (item.ID == this.addproduct[index].variant_id) {
            this.variants.splice(index, 1, item);
            console.log("this.variants", this.variants);
            return true;
          }
        });
      }
      console.log(this.variants);
    },
    startMove(e) {
      this.startX = e.targetTouches[0].clientX; // 获取触控时x坐标
    },
    endMove(e) {
      this.endX = e.changedTouches[0].clientX;
      if (this.distance > 50) {
        this.prev();
      } else if (this.distance < -50 && this.slides < this.click_num) {
        this.next();
      }
    }
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
    this.change_like();
  },
  mounted() {},
  watch: {},
  computed: {
    // 手指触碰与离开的差值
    distance() {
      return this.endX - this.startX;
    }
  },
  components: {
    vCommentsStar
  }
};
</script>
<style scoped lang='scss'>
.guess_like {
  margin-top: 20px;
  position: relative;
  .guess_title {
    font-size: 32px !important;
    line-height: 36px !important;
    color: #333;
    padding: 20px 0;
    margin: 0;
    text-align: left;
    text-transform: capitalize;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    span {
      margin: 0;
      -webkit-tap-highlight-color: transparent;
      display: inline-block;
      max-width: 70%;
      padding: 0;
      font-weight: 400;
    }
    em {
      font-style: italic;
      font-weight: 400;
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
      font-size: 14px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .guess_list_wrap {
    & > span {
      margin: 0;
      padding: 0;
      position: absolute;
      cursor: pointer;
      left: auto;
      width: 20px;
      height: 32px;
      background: #f2f2f2;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      color: #666;
      top: 80px;
      z-index: 99;
    }
    & > span:nth-child(1) {
      left: 0;
    }
    & > span:nth-child(2) {
      right: 0;
    }
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    padding: 0;
    .guess_list_box {
      margin: 0;
      padding: 0;
      position: relative;
      z-index: 1;
      box-sizing: content-box;
      outline: 0;
      display: flex;
      left: 0px;
      .guess_list_item {
        flex-shrink: 0;
        list-style: none;
        width: 25%;
        padding: 8px 28px 8px 8px;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        flex-direction: column;

        .item_gallery {
          width: 100%;
          position: relative;
          box-sizing: border-box;
          // height: 211px;
          margin-bottom: 8px;

          padding-top: 100%;
          a {
            position: absolute;
            top: 0;
            left: 0;

            margin: 0;
            padding: 0;
            text-decoration: none;
            -webkit-tap-highlight-color: transparent;
            outline: 0;
            display: flex;
            height: 100%;
            width: 100%;
            justify-content: center;
            align-items: center;
            img {
              max-width: 100%;
              max-height: 100%;
              display: block;
              margin: 0 auto;
            }
          }
          .sale_tag {
            position: absolute;
            right: 0;
            top: 0;
            padding: 6px 12px;
            color: #fff;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            z-index: 1;
            background: #333;
          }
        }

        .item_name {
          margin: 0 auto;
          margin-bottom: 8px;
          width: 100%;
          a {
            color: #666;
            font-size: 14px;
            text-decoration: none;
          }
          .oneline {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .item_attribute {
          width: 100%;
          color: #737373;
          height: 24px;
          margin-bottom: 8px;
          select {
            width: 100%;
            height: 100%;
            border: 1px solid #dfdfdf;
            padding: 0 25px 0 10px;
            box-sizing: border-box;
            z-index: 1;
            position: relative;
            color: #737373;
            border-radius: 4px;
            outline: 0;
            appearance: none;
            -webkit-appearance: none;
          }
        }
        .has_select {
          position: relative;
          &::after {
            font-family: iconfont !important;
            -webkit-font-smoothing: antialiased;
            content: "\E63C";
            font-size: 14px;
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 999;
            pointer-events: none;
          }
        }
        .item_price {
          text-align: center;
          margin: 0 auto;
          margin-bottom: 26px;
          padding: 0;
          .price {
            font-size: 14px;
            margin: 0 2px;
            font-weight: 700;
          }
          .regular_price {
            font-size: 14px;
            margin: 0 2px;
            text-decoration: line-through;
            color: rgb(123, 119, 130);
            display: inline-block;
          }
        }
        .item_star {
          -webkit-tap-highlight-color: transparent;
          height: 18px;
          display: inline-flex;
          justify-content: left;
          align-items: center;
          margin: 0 auto;
          margin-bottom: 8px;
        }
        .item_button {
          display: inline-block;
          line-height: 1;
          cursor: pointer;
          background: #fff;
          border: 1px solid #dcdfe6;
          -webkit-appearance: none;
          text-align: center;
          box-sizing: border-box;
          outline: 0;
          transition: 0.1s;
          font-weight: 500;
          border-radius: 4px;
          font-family: LatoRegular !important;
          color: rgba(0, 0, 0, 1);
          border-color: rgba(0, 0, 0, 1);
          background-color: rgba(255, 255, 255, 1);
          margin: 0 auto;
          margin-bottom: 8px;
          padding: 10px 0;
          width: 100%;
          font-size: 14px;
        }
        #slodout {
          background-color: #969696 !important;
          border-color: #969696 !important;
          color: white !important;
          cursor: default !important;
        }
      }
    }
  }
}
@media screen and(max-width: 575px) {
  .guess_like {
    .guess_list_wrap {
      .guess_list_box {
        .guess_list_item {
          width: 50%;
          padding: 8px;
        }
      }
    }
  }
}
</style>